import NetworkUtil from "./NetworkUtil";
import { FAQ } from "../types/FAQ";
import { Category } from "../types/Category";
import { ServerResponse } from "../types/ServerResponse";

export default class FAQAPI {

    // Active FAQs for all logged-in users (view page)
    public static async getActiveFAQs(): Promise<{ success: boolean, reason: string, data: FAQ[] }> {
        return NetworkUtil.makePost("/api/admin/faq/getActive", {});
    }

    // All FAQs for the management page (global admins)
    public static async getAllFAQs(): Promise<{ success: boolean, reason: string, data: FAQ[] }> {
        return NetworkUtil.makePost("/api/admin/faq/getAll", {});
    }

    public static async createFAQ(faq: Partial<FAQ>): Promise<ServerResponse> {
        return NetworkUtil.makePost("/api/admin/faq/create", faq);
    }

    public static async editFAQ(faq: Partial<FAQ>): Promise<ServerResponse> {
        return NetworkUtil.makePost("/api/admin/faq/edit", faq);
    }

    public static async updateSortOrder(faqs: FAQ[]): Promise<ServerResponse> {
        return NetworkUtil.makePost("/api/admin/faq/updateSortOrder", faqs);
    }

    public static async getCategories(): Promise<{ success: boolean, reason: string, data: Category[] }> {
        return NetworkUtil.makePost("/api/admin/faq/categories/getActive", {});
    }

    public static async getAllCategories(): Promise<{ success: boolean, reason: string, data: Category[] }> {
        return NetworkUtil.makePost("/api/admin/faq/categories/getAll", {});
    }

    public static async createCategory(category: Partial<Category>): Promise<ServerResponse> {
        return NetworkUtil.makePost("/api/admin/faq/categories/create", category);
    }

    public static async editCategory(category: Partial<Category>): Promise<ServerResponse> {
        return NetworkUtil.makePost("/api/admin/faq/categories/edit", category);
    }

    // Downloads the Compendium spreadsheet (.xlsx) from the configured link
    public static async downloadCompendium(): Promise<boolean> {
        return NetworkUtil.downloadCSV("/api/admin/faq/compendium", "compendium.xlsx", {});
    }
}
